import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Industry pages
export const IndustryListPage = lazy(
  () =>
    retry(() => import('@pages/settings/industries/list')) as Promise<
      typeof import('@pages/settings/industries/list')
    >
);

export const IndustryEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/industries/edit')) as Promise<
      typeof import('@pages/settings/industries/edit')
    >
);

export const IndustryCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/industries/create')) as Promise<
      typeof import('@pages/settings/industries/create')
    >
);

// Segment pages
export const SegmentListPage = lazy(
  () =>
    retry(() => import('@pages/settings/segments/list')) as Promise<
      typeof import('@pages/settings/segments/list')
    >
);

export const SegmentEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/segments/edit')) as Promise<
      typeof import('@pages/settings/segments/edit')
    >
);

export const SegmentCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/segments/create')) as Promise<
      typeof import('@pages/settings/segments/create')
    >
);

// Life Cycle pages
export const LifeCycleListPage = lazy(
  () =>
    retry(() => import('@pages/settings/life-cycles/list')) as Promise<
      typeof import('@pages/settings/life-cycles/list')
    >
);

export const LifeCycleEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/life-cycles/edit')) as Promise<
      typeof import('@pages/settings/life-cycles/edit')
    >
);

export const LifeCycleCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/life-cycles/create')) as Promise<
      typeof import('@pages/settings/life-cycles/create')
    >
);

// Churn Reason pages
export const ChurnReasonListPage = lazy(
  () =>
    retry(() => import('@pages/settings/churn-reasons/list')) as Promise<
      typeof import('@pages/settings/churn-reasons/list')
    >
);

export const ChurnReasonEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/churn-reasons/edit')) as Promise<
      typeof import('@pages/settings/churn-reasons/edit')
    >
);

export const ChurnReasonCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/churn-reasons/create')) as Promise<
      typeof import('@pages/settings/churn-reasons/create')
    >
);

// Document Type pages
export const DocumentTypeListPage = lazy(
  () =>
    retry(() => import('@pages/settings/document-types/list')) as Promise<
      typeof import('@pages/settings/document-types/list')
    >
);

export const DocumentTypeEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/document-types/edit')) as Promise<
      typeof import('@pages/settings/document-types/edit')
    >
);

export const DocumentTypeCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/document-types/create')) as Promise<
      typeof import('@pages/settings/document-types/create')
    >
);

// Contact Type pages
export const ContactTypeListPage = lazy(
  () =>
    retry(() => import('@pages/settings/contact-types/list')) as Promise<
      typeof import('@pages/settings/contact-types/list')
    >
);

export const ContactTypeEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/contact-types/edit')) as Promise<
      typeof import('@pages/settings/contact-types/edit')
    >
);

export const ContactTypeCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/contact-types/create')) as Promise<
      typeof import('@pages/settings/contact-types/create')
    >
);

// Approval Flow pages
export const ApprovalFlowListPage = lazy(
  () =>
    retry(() => import('@pages/settings/approval-flows/list')) as Promise<
      typeof import('@pages/settings/approval-flows/list')
    >
);

export const ApprovalFlowEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/approval-flows/edit')) as Promise<
      typeof import('@pages/settings/approval-flows/edit')
    >
);

export const ApprovalFlowCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/approval-flows/create')) as Promise<
      typeof import('@pages/settings/approval-flows/create')
    >
);
